import actionType from "./_actions";

const _saveFruit = (offlineFarms, payload) => {
    const { farmId, budgetId, blockId, fruit } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    const blocks = offlineBudget.budget.blocks.map((block) => {
                        if (block.id !== blockId) return block;

                        // Auto add/remove animals
                        if (fruit.swardAnimalSource === "EnterpriseStock") {
                            let animals = block.animals || [];
                            if (animals.length === 0) {
                                (offlineBudget.budget.enterprises || [])
                                    .filter((enterprise) => enterprise.type !== "OutdoorPigs")
                                    .forEach((enterprise) => {
                                        if (!animals.some((a) => a.enterpriseId === enterprise.id)) {
                                            animals = animals.concat({
                                                enterpriseId: enterprise.id,
                                                months: [],
                                            });
                                        }
                                    });
                            }
                            return {
                                ...block,
                                fruit,
                                animals,
                            };
                        } else {
                            return {
                                ...block,
                                animals: [],
                                fruit,
                            };
                        }
                    });

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            blocks,
                        },
                    };
                }),
            },
        };
    });
};

const reducer = (state = [], action) => {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionType.FRUIT_SAVE:
            return _saveFruit(offlineFarms, action.payload);

        default:
            return offlineFarms;
    }
};

export default reducer;
